const prescriptions = [
  {
    path: '/rule/set',
    name: 'rule_set',
    component: () => import( '@/pages/rule/set'),
    meta: {keepAlive: true, name: '规则设置'},
  },

  {
    path: '/rule/interact',
    name: 'rule_interact',
    component: () => import( '@/pages/rule/interact'),
    meta: {keepAlive: true, name: '相互作用'},
  },
  {
    path: '/rule/repeatedmedication',
    name: 'rule_repeatedmedication',
    component: () => import( '@/pages/rule/repeatedmedication'),
    meta: {keepAlive: true, name: '重复用药'},
  },
  {
    path: '/rule/specialpopulations',
    name: 'rule_specialpopulations',
    component: () => import( '@/pages/rule/specialpopulations'),
    meta: {keepAlive: true, name: '特殊人群'},
  },
  {
    path: '/rule/usageanddosage',
    name: 'rule_usageanddosage',
    component: () => import( '@/pages/rule/usageanddosage'),
    meta: {keepAlive: true, name: '用法用量'},
  },
  {
    path: '/rule/diagnosecontraindication',
    name: 'rule_diagnosecontraindication',
    component: () => import( '@/pages/rule/diagnosecontraindication'),
    meta: {keepAlive: true, name: '用法用量'},
  },
  {
    path: '/rule/diagnosepopular',
    name: 'rule_diagnosepopular',
    component: () => import( '@/pages/rule/diagnosepopular'),
    meta: {keepAlive: true, name: '诊断用户'},
  },
]

export default prescriptions



// WEBPACK FOOTER //
// ./src/router/modules/rule.js